<ng-container *ngIf="planActivationSummary$ | async as summary; else loading">
  <div class="row">
    <div class="col-xl-8">
      <div class="card mt-4 ms-4">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Purchase Plan</h2>
          </div>
          <div class="row pt-5">
            <div class="col-lg-12">
              <!--<h4 class="col-lg-12 text-lg-center py-4">Plan details</h4>-->
              <div class="row">
                <p class="col-lg-6 text-lg-end">Plan:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.name }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.price
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div *ngIf="summary.plan.discount > 0" class="row">
                <p class="col-lg-6 text-lg-end">Discounted Price:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.discountedPrice
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Billing Frequency:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.billingFrequency | capitalize }}</p>
              </div>
              <!-- <div class="row align-items-center">
                <p class="col-lg-6 text-lg-end">Total Licences:</p>
                <div class="col-lg-6">
                  <div class="input-group" style="max-width: 150px">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences - 1,
                          summary.plan.minimumLicences
                        )
                      "
                      [disabled]="summary.plan.requestedLicences <= summary.plan.minimumLicences"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="form-control text-center"
                      [value]="summary.plan.requestedLicences"
                      [min]="summary.plan.minimumLicences"
                      (input)="
                        onLicenceChange(
                          $any($event.target).valueAsNumber,
                          summary.plan.minimumLicences
                        )
                      "
                      aria-label="Number of licences"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences + 1,
                          summary.plan.minimumLicences
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
               -->
              <div class="row align-items-center">
                <!-- <p class="col-lg-6 text-lg-end">Total Licences:</p> -->
                <p
                  class="col-lg-6 d-flex justify-content-lg-end justify-content-center align-items-center mb-0"
                >
                  Total Licences:
                </p>
                <div class="col-lg-6">
                  <div class="input-group input-group-sm" style="max-width: 120px">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences - 1,
                          summary.plan.minimumLicences
                        )
                      "
                      [disabled]="summary.plan.requestedLicences <= summary.plan.minimumLicences"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="form-control text-center"
                      [value]="summary.plan.requestedLicences"
                      [min]="summary.plan.minimumLicences"
                      (input)="
                        onLicenceChange(
                          $any($event.target).valueAsNumber,
                          summary.plan.minimumLicences
                        )
                      "
                      aria-label="Number of licences"
                    />
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="
                        onLicenceChange(
                          summary.plan.requestedLicences + 1,
                          summary.plan.minimumLicences
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Used Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.usedLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Minimum Licences:</p>
                <p class="col-lg-6 fw-bold">{{ summary.plan.minimumLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Recurring Amount:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    summary.plan.recurringAmount
                      | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Next Billing Date:</p>
                <p class="col-lg-6 fw-bold">
                  {{ summary.plan.nextBillingDate | date: 'mediumDate' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 theiaStickySidebar">
      <div class="card mt-4 me-4">
        <div class="card-body">
          <div class="d-flex justify-content-between border-bottom pb-2 pt-4">
            <h2>Billing Summary</h2>
          </div>
          <div class="total-row pt-4">
            <div class="amount-due">
              <span class="label">Amount Payable</span>
              <span class="value">
                {{
                  summary.billingSummary.amountToBePaid
                    | currency: summary.billingSummary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
          </div>

          <div class="d-grid mt-4">
            <button (click)="activateSubscription()" class="btn btn-primary" type="button">
              Pay Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center p-5">
    <!--<p>Loading plan summary...</p>-->
  </div>
</ng-template>
